<template>
  <b-sidebar
    id="edit-enrollment-sidebar"
    :visible="isEditEnrollmentSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="$emit('clicked')"
    @change="(val) => $emit('one')"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Enrollment
        </h5>
        </div>
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
        <h5 class="text-center"></b>{{ form.code }} - {{ form.zh_name }} {{ form.en_name }}
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              block
              :to="'/apps/member/'+ form.uuid + '/class/add/'"
              size="sm"
              class="mt-2"
              variant="outline-primary"
            >
              付款
            </b-button></h5>
            <hr />
        <b-form-group
          label="編號"
          label-for=""
        >
          <b-form-input
            id=""
            v-model="form.id"
            trim
            disabled
          />
        </b-form-group>


       
        <b-form-group
          label="題材"
          label-for=""
        >
          <b-form-input
            id=""
            v-model="form.todo_content"
            trim
          />
        </b-form-group>
        


        <hr />
        <!-- <img :src="form.image + '?rand=' + rand_number" v-if='form.image != null' style="width:100%;" class="mb-1"> -->
        <!-- 
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="warning"
          class="mr-2"
          block
          type="button"
          @click="capture()"
        >
          拍攝作品
        </b-button> -->
      </b-form>


      <!-- BODY -->
      <validation-observer
        ref="simpleRules"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >


          <!-- Form Actions -->
     
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="button"
              block
              @click="update()"
            >
              確定 
            </b-button>
            <b-button
              v-if="form.enrollment_type == 'TRIAL'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="mt-1"
              type="button"
              block
              @click="check_form(form.id)"
            >
              試堂評估表 
            </b-button>
    
          <hr />
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              block
              @click="delete_enrollment"
              size="sm"
              class="mb-2"
              variant="danger"
            >
              刪除
            </b-button>
            
            <br>
            <b-list-group-item v-for="(item, index) in todo" :key="index" :class="todo.class">
              <b-badge :variant="item.class" >{{ item.class_date }}</b-badge> {{  item.todo_content }}
              <span v-if="item.is_attend === null"><b>(未上堂)</b></span>
            </b-list-group-item>
        </b-form>
      </validation-observer>
      
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,BListGroup,BListGroupItem,BBadge
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import countries from '@/@fake-db/data/other/countries'

export default {
  components: {
    ToastificationContent,
    flatPickr,
    BSidebar,
    BForm,
    BBadge,
    BListGroup,
    BListGroupItem,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isEditEnrollmentSidebarActive',
    event: 'update:is-edit-enrollment-sidebar-active',
  },
  props: {
    isEditEnrollmentSidebarActive: {
      type: Boolean,
      required: true,
    },
    form : {
      type: Object,
      required: true
    },
    todo : {
        type: Array,
        required: false
    }
  },
  data() {
    return {
      required,
      rand_number,
      alphaNum,
      email,
      countries,
      form : {
        id : 0,
        todo_category : null,
        todo_content : null
      }
    }
  },
  watch: {
    isEditEnrollmentSidebarActive() {
      //this.rand_number = Math.floor(Math.random() * 1000)
    }
  },
  created() {
    
  },
  methods: {
    check_form(id) {
      this.$http.get(process.env.VUE_APP_API_BASE+'/form/check/?type=trial&enrollment_id='+ id)
        .then(res => {
          if (res.data.result === true) {
            this.$router.replace('form/'+ this.form.student_id +'/1/?enrollment_id='+id);
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    change_class_all(id) {
      this.$http.post(process.env.VUE_APP_API_BASE+'/enrollment/'+this.form.id+'/change_class_all/', {id:id})
        .then(res => {
          if (res.data.result === true) {
            this.$emit('clicked', false)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    delete_enrollment() {
      this.$http.post(process.env.VUE_APP_API_BASE+'/enrollment/'+this.form.id+'/delete/', this.form)
        .then(res => {
          if (res.data.result === true) {
            this.$emit('clicked', false)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    capture() {
      this.$emit('snapshot_now', false)
      this.$emit('clicked', false)
    },
    update() {
      this.$http.post(process.env.VUE_APP_API_BASE+'/enrollment/'+this.form.id+'/update_todo/', this.form)
        .then(res => {
          if (res.data.result === true) {
            this.$emit('clicked', false)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.form-group {
   margin-bottom: .5rem !important;
 }
</style>
